module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('b-breadcrumb', [_c('b-breadcrumb-item', {
    attrs: {
      "text": "Home",
      "to": "/"
    }
  }), _vm._v(" "), _c('b-breadcrumb-item', {
    attrs: {
      "text": "Dashboard",
      "active": true
    }
  })], 1), _vm._v(" "), (_vm.metrics !== null) ? _c('b-container', {
    ref: "container",
    staticStyle: {
      "background-color": "#fff"
    },
    attrs: {
      "fluid": ""
    }
  }, [_c('b-row', [_c('b-col', {
    staticClass: "mt-2 mb-2",
    attrs: {
      "lg": "12",
      "md": "12",
      "sm": "12",
      "xs": "12"
    }
  }, [_c('collapsible-card', {
    attrs: {
      "title": "Server Info",
      "visible": true
    }
  }, [_c('b-row', {
    staticClass: "p-2"
  }, [_c('b-col', [_c('b-form-group', {
    attrs: {
      "label": "Group:",
      "label-for": "group",
      "description": "Select the server group to display"
    }
  }, [(_vm.groupOptions !== null) ? _c('b-input-group', [_c('b-form-select', {
    attrs: {
      "placeholder": "Select Group",
      "options": _vm.groupOptions
    },
    model: {
      value: (_vm.group),
      callback: function($$v) {
        _vm.group = $$v
      },
      expression: "group"
    }
  })], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Display Mode:",
      "label-for": "displayMode",
      "description": ""
    }
  }, [_c('b-form-radio-group', {
    attrs: {
      "id": "display-mode",
      "options": _vm.displayModeOptions,
      "buttons": "",
      "button-variant": "outline-primary",
      "name": "display-mode"
    },
    model: {
      value: (_vm.displayMode),
      callback: function($$v) {
        _vm.displayMode = $$v
      },
      expression: "displayMode"
    }
  })], 1)], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Full:",
      "label-for": "full",
      "description": ""
    }
  }, [_c('b-button', {
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.fullScreen()
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "arrows-alt"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('b-card-text', {
    staticStyle: {
      "overflow": "auto",
      "height": "440px"
    }
  }, [(_vm.displayMode === 'bar') ? _c('table', {
    staticClass: "table table-striped table-hover table-bordered"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Server")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    attrs: {
      "width": "20%"
    }
  }, [_vm._v("CPU")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    attrs: {
      "width": "20%"
    }
  }, [_vm._v("Memory")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    attrs: {
      "width": "20%"
    }
  }, [_vm._v("Swap")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    attrs: {
      "width": "20%"
    }
  }, [_vm._v("Disk")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Action")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.metrics), function(item) {
    return (_vm.isMatchGroup(item.server)) ? _c('tr', [_c('td', {
      on: {
        "click": function($event) {
          return _vm.viewServerDashboard(item.server.id)
        }
      }
    }, [_c('span', {
      style: ('cursor:pointer; color: ' + item.server.color)
    }, [_vm._v(_vm._s(item.server.name))]), _vm._v(" "), (_vm.isVisible(item.server)) ? _c('span', {
      staticClass: "float-right"
    }, [_c('icon', {
      attrs: {
        "name": "eye"
      }
    })], 1) : _vm._e()]), _vm._v(" "), _c('td', [_c('b-progress', {
      attrs: {
        "value": item.current.cpu.usage,
        "max": 100,
        "height": "2rem",
        "animated": ""
      }
    })], 1), _vm._v(" "), _c('td', [_c('b-progress', {
      attrs: {
        "value": item.current.memory.usage,
        "max": 100,
        "height": "2rem",
        "animated": ""
      }
    })], 1), _vm._v(" "), _c('td', [_c('b-progress', {
      attrs: {
        "value": item.current.swap.usage,
        "max": 100,
        "height": "2rem",
        "animated": ""
      }
    })], 1), _vm._v(" "), _c('td', [_c('b-progress', {
      attrs: {
        "value": item.current.disk.usage,
        "max": 100,
        "height": "2rem",
        "animated": ""
      }
    })], 1), _vm._v(" "), _c('td', [_c('b-link', {
      on: {
        "click": function($event) {
          return _vm.setVisible(item.server, true)
        }
      }
    }, [_c('icon', {
      attrs: {
        "name": "eye"
      }
    })], 1), _vm._v(" "), _c('b-link', {
      on: {
        "click": function($event) {
          return _vm.setVisible(item.server, false)
        }
      }
    }, [_c('icon', {
      attrs: {
        "name": "eye-slash"
      }
    })], 1)], 1)]) : _vm._e()
  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.displayMode === 'text') ? _c('table', {
    staticClass: "table table-striped table-hover table-bordered"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Server")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    attrs: {
      "width": "20%",
      "colspan": "3"
    }
  }, [_vm._v("CPU")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    attrs: {
      "width": "20%",
      "colspan": "3"
    }
  }, [_vm._v("Memory")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    attrs: {
      "width": "20%",
      "colspan": "3"
    }
  }, [_vm._v("Swap")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    attrs: {
      "width": "20%",
      "colspan": "3"
    }
  }, [_vm._v("Disk")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Action")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td'), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v("User")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v("System")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v("Total")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v("Free")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v("Used")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v("Total")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v("Free")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v("Used")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v("Total")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v("Free")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v("Used")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v("Total")]), _vm._v(" "), _c('td')]), _vm._v(" "), _vm._l((_vm.metrics), function(item) {
    return (_vm.isMatchGroup(item.server)) ? _c('tr', [_c('td', {
      on: {
        "click": function($event) {
          return _vm.viewServerDashboard(item.server.id)
        }
      }
    }, [_c('span', {
      style: ('cursor:pointer; color: ' + item.server.color)
    }, [_vm._v(_vm._s(item.server.name))]), _vm._v(" "), (_vm.isVisible(item.server)) ? _c('span', {
      staticClass: "float-right"
    }, [_c('icon', {
      attrs: {
        "name": "eye"
      }
    })], 1) : _vm._e()]), _vm._v(" "), _c('td', {
      attrs: {
        "align": "right"
      }
    }, [_vm._v(_vm._s(_vm._f("percentage")(item.current.cpu.user)))]), _vm._v(" "), _c('td', {
      attrs: {
        "align": "right"
      }
    }, [_vm._v(_vm._s(_vm._f("percentage")(item.current.cpu.system)))]), _vm._v(" "), _c('td', {
      attrs: {
        "align": "right"
      }
    }, [_vm._v(_vm._s(_vm._f("percentage")(item.current.cpu.usage)))]), _vm._v(" "), _c('td', {
      attrs: {
        "align": "right"
      }
    }, [_vm._v(_vm._s(_vm._f("size")(item.current.memory.free)))]), _vm._v(" "), _c('td', {
      attrs: {
        "align": "right"
      }
    }, [_vm._v(_vm._s(_vm._f("size")(item.current.memory.used)) + " (" + _vm._s(_vm._f("percentage")(item.current.memory.usage)) + ")")]), _vm._v(" "), _c('td', {
      attrs: {
        "align": "right"
      }
    }, [_vm._v(_vm._s(_vm._f("size")(item.current.memory.free + item.current.memory.used)))]), _vm._v(" "), _c('td', {
      attrs: {
        "align": "right"
      }
    }, [_vm._v(_vm._s(_vm._f("size")(item.current.swap.free)))]), _vm._v(" "), _c('td', {
      attrs: {
        "align": "right"
      }
    }, [_vm._v(_vm._s(_vm._f("size")(item.current.swap.used)) + " (" + _vm._s(_vm._f("percentage")(item.current.swap.usage)) + ")")]), _vm._v(" "), _c('td', {
      attrs: {
        "align": "right"
      }
    }, [_vm._v(_vm._s(_vm._f("size")(item.current.swap.free + item.current.swap.used)))]), _vm._v(" "), _c('td', {
      attrs: {
        "align": "right"
      }
    }, [_vm._v(_vm._s(_vm._f("size")(item.current.disk.free)))]), _vm._v(" "), _c('td', {
      attrs: {
        "align": "right"
      }
    }, [_vm._v(_vm._s(_vm._f("size")(item.current.disk.used)) + " (" + _vm._s(_vm._f("percentage")(item.current.disk.usage)) + ")")]), _vm._v(" "), _c('td', {
      attrs: {
        "align": "right"
      }
    }, [_vm._v(_vm._s(_vm._f("size")(item.current.disk.free + item.current.disk.used)))]), _vm._v(" "), _c('td', [_c('b-link', {
      on: {
        "click": function($event) {
          return _vm.setVisible(item.server, true)
        }
      }
    }, [_c('icon', {
      attrs: {
        "name": "eye"
      }
    })], 1), _vm._v(" "), _c('b-link', {
      on: {
        "click": function($event) {
          return _vm.setVisible(item.server, false)
        }
      }
    }, [_c('icon', {
      attrs: {
        "name": "eye-slash"
      }
    })], 1)], 1)]) : _vm._e()
  })], 2)]) : _vm._e()])], 1)], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mt-2 mb-2",
    attrs: {
      "lg": "6",
      "md": "6",
      "sm": "6",
      "xs": "12"
    }
  }, [_c('b-card', {
    scopedSlots: _vm._u([{
      key: "header",
      fn: function() {
        return [_c('b-row', [_c('b-col', {
          attrs: {
            "cols": "9"
          }
        }, [_c('h4', {
          staticClass: "card-title"
        }, [_vm._v("CPU Trend")])]), _vm._v(" "), _c('b-col', {
          staticClass: "text-right",
          attrs: {
            "cols": "3"
          }
        }, [_c('icon', {
          attrs: {
            "name": "microchip",
            "scale": "1"
          }
        })], 1)], 1)]
      },
      proxy: true
    }], null, false, 3667682035)
  }, [_vm._v(" "), _c('b-card-text', [_c('line-chart', {
    ref: "cpuTrendChart",
    attrs: {
      "chartData": _vm.cpu.trend.chartData,
      "options": _vm.cpu.trend.chartOptions
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mt-2 mb-2",
    attrs: {
      "lg": "6",
      "md": "6",
      "sm": "6",
      "xs": "12"
    }
  }, [_c('b-card', {
    scopedSlots: _vm._u([{
      key: "header",
      fn: function() {
        return [_c('b-row', [_c('b-col', {
          attrs: {
            "cols": "9"
          }
        }, [_c('h4', {
          staticClass: "card-title"
        }, [_vm._v("Memory")])]), _vm._v(" "), _c('b-col', {
          staticClass: "text-right",
          attrs: {
            "cols": "3"
          }
        }, [_c('icon', {
          attrs: {
            "name": "memory",
            "scale": "1"
          }
        })], 1)], 1)]
      },
      proxy: true
    }], null, false, 1372592084)
  }, [_vm._v(" "), _c('b-card-text', [_c('line-chart', {
    ref: "memoryTrendChart",
    attrs: {
      "chartData": _vm.memory.trend.chartData,
      "options": _vm.memory.trend.chartOptions
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mt-2 mb-2",
    attrs: {
      "lg": "6",
      "md": "6",
      "sm": "6",
      "xs": "12"
    }
  }, [_c('b-card', {
    scopedSlots: _vm._u([{
      key: "header",
      fn: function() {
        return [_c('b-row', [_c('b-col', {
          attrs: {
            "cols": "9"
          }
        }, [_c('h4', {
          staticClass: "card-title"
        }, [_vm._v("Disk Activity")])]), _vm._v(" "), _c('b-col', {
          staticClass: "text-right",
          attrs: {
            "cols": "3"
          }
        }, [_c('icon', {
          attrs: {
            "name": "hdd",
            "scale": "1"
          }
        })], 1)], 1)]
      },
      proxy: true
    }, {
      key: "footer",
      fn: function() {
        return [_vm._v("\n\t\t\t\t\t\tGraph going up is bytes read, graph going down is bytes written\n\t\t\t\t\t")]
      },
      proxy: true
    }], null, false, 111785203)
  }, [_vm._v(" "), _c('b-card-text', [_c('line-chart', {
    ref: "disksActivityTrendChart",
    attrs: {
      "chartData": _vm.disks.activity.chartData,
      "options": _vm.disks.activity.chartOptions
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mt-2 mb-2",
    attrs: {
      "lg": "6",
      "md": "6",
      "sm": "6",
      "xs": "12"
    }
  }, [_c('b-card', {
    scopedSlots: _vm._u([{
      key: "header",
      fn: function() {
        return [_c('b-row', [_c('b-col', {
          attrs: {
            "cols": "9"
          }
        }, [_c('h4', {
          staticClass: "card-title"
        }, [_vm._v("Network Activity")])]), _vm._v(" "), _c('b-col', {
          staticClass: "text-right",
          attrs: {
            "cols": "3"
          }
        }, [_c('icon', {
          attrs: {
            "name": "network-wired"
          }
        })], 1)], 1)]
      },
      proxy: true
    }, {
      key: "footer",
      fn: function() {
        return [_vm._v("\n\t\t\t\t\t\tGraph going up is bytes received, graph going down is bytes sent\n\t\t\t\t\t")]
      },
      proxy: true
    }], null, false, 2580753639)
  }, [_vm._v(" "), _c('b-card-text', [_c('line-chart', {
    ref: "networkTrendChart",
    attrs: {
      "chartData": _vm.network.chartData,
      "options": _vm.network.chartOptions
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mt-2 mb-2",
    attrs: {
      "lg": "6",
      "md": "6",
      "sm": "6",
      "xs": "12"
    }
  }, [_c('b-card', {
    scopedSlots: _vm._u([{
      key: "header",
      fn: function() {
        return [_c('b-row', [_c('b-col', {
          attrs: {
            "cols": "9"
          }
        }, [_c('h4', {
          staticClass: "card-title"
        }, [_vm._v("Swap")])]), _vm._v(" "), _c('b-col', {
          staticClass: "text-right",
          attrs: {
            "cols": "3"
          }
        }, [_c('icon', {
          attrs: {
            "name": "memory",
            "scale": "1"
          }
        })], 1)], 1)]
      },
      proxy: true
    }], null, false, 90687552)
  }, [_vm._v(" "), _c('b-card-text', [_c('line-chart', {
    ref: "swapTrendChart",
    attrs: {
      "chartData": _vm.swap.trend.chartData,
      "options": _vm.swap.trend.chartOptions
    }
  })], 1)], 1)], 1)], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-52efb299","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/dashboard/DashboardPage.vue
// module id = 2143
// module chunks = 1